import React from "react";
import "./HowItWorksPage.scss";
import Container from "../../shared/ui/Container";
const HowItWorksPage = () => {
  const steps = [
    {
      id: 1,
      title: "Discovery & Planning",
      description:
        "We start by understanding your product, users, and business goals. Our team reviews your design, user flows, and accessibility priorities to plan a customized testing approach.",
    },
    {
      id: 2,
      title: "Manual & Automated Testing",
      description:
        "We combine smart automated tools with manual testing on real devices — no emulators or shortcuts. This helps us detect not only compliance issues but also real user experience barriers.",
    },
    {
      id: 3,
      title: "Reporting & Solutions",
      description:
        "You receive a clear, structured report with issues, explanations, and actionable fixes. Each finding includes practical recommendations and visual examples.",
    },
    {
      id: 4,
      title: "Verification & Support",
      description:
        "After your team applies fixes, we re-test to ensure full compliance and usability. We also provide ongoing guidance to help you maintain accessibility standards as your product evolves.",
    },
    {
      id: 5,
      title: "Accessibility Compliance Statement",
      description:
        "Upon successful verification, we provide an Accessibility Compliance Statement. This statement is recognized across Canada and can be shared publicly to demonstrate your commitment to inclusion and accessibility excellence.",
    },
  ];

  return (
    <div className="how-it-works-page">
      <section
        className="page-header"
        aria-labelledby="page-title"
      >
        <Container>
          <h1 id="page-title" className="page-header__title">
            How It Works
          </h1>
          <p className="page-header__subtitle">
            We make digital accessibility clear, human, and effective — from the
            first audit to the final delivery.
          </p>
        </Container>
      </section>

      <section className="process-section" aria-labelledby="process-title">
        <div className="process-section__container">
          <h2 id="process-title" className="process-section__title">
            Our Process
          </h2>
          <div className="steps-timeline">
            {steps.map((step, index) => (
              <article key={step.id} className="step-card">
                <div
                  className="step-card__number"
                  aria-label={`Step ${step.id}`}
                >
                  {step.id}
                </div>
                <div className="step-card__content">
                  <h3 className="step-card__title">{step.title}</h3>
                  <p className="step-card__description">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className="step-card__connector"
                    aria-hidden="true"
                  ></div>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="benefits-section" aria-labelledby="benefits-title">
        <div className="benefits-section__container">
          <h2 id="benefits-title" className="benefits-section__title">
            Benefits of Our Approach
          </h2>
          <ul className="benefits-list">
            <li className="benefits-list__item">
              <strong>Comprehensive Coverage:</strong> We address all aspects of
              web accessibility, from design and development to content. Our
              audits include clear explanations, visual examples, and practical
              recommendations, making it easy for your team to fix and learn.
            </li>
            <li className="benefits-list__item">
              <strong>Expert Guidance:</strong> Our team has years of experience
              in accessibility compliance and best practices. We go beyond WCAG
              checklists — focusing on usability, empathy, and business impact
              to help you reach more users.
            </li>
            <li className="benefits-list__item">
              <strong>Proven Results:</strong> We've helped numerous
              organizations achieve and maintain accessibility compliance. Our
              clients appreciate our transparency, communication, and commitment
              to results.
            </li>
            <li className="benefits-list__item">
              <strong>Long-term Success:</strong> Our goal isn’t just to fix
              issues — it’s to equip your team to champion accessibility every
              day.
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default HowItWorksPage;
